// Helper privado compartilhado pelos dois modulos de mutations.
// NAO e reexportado pelo barrel `mutations.js` — se fosse, viraria uma
// mutation no store Vuex (`export const mutations = { ...m }` em index.js).

// As mutations de lista resolvem a pasta em QUALQUER nível: uma lista pode
// ser criada/editada/removida dentro de uma subpasta e um `find` só na raiz
// faria a mutation virar no-op silencioso (a lista só apareceria após reload).
export function _findFolderNode(list, folderId) {
  if (!Array.isArray(list) || !list.length) return undefined
  for (const node of list) {
    if (!node) continue
    if (node.id === folderId) return node
    const found = _findFolderNode(node.subpastas, folderId)
    if (found) return found
  }
  return undefined
}
